import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Ensure axios sends cookies
axios.defaults.withCredentials = true;

export const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Login sets httpOnly cookie automatically
      await axios.post(`${API}/admin/login`, credentials);
      toast.success('Admin login successful');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF9F6] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1
            className="text-4xl md:text-5xl font-medium tracking-tight text-stone-800 mb-3"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Admin Access
          </h1>
          <p className="text-stone-600">Mindful Renewal Management</p>
        </div>

        <div className="bg-white/60 backdrop-blur-md border border-[#EAE4DC] shadow-lg rounded-2xl p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                required
                data-testid="admin-username-input"
                className="bg-white/60 border-stone-200 focus:border-stone-400 focus:ring-4 focus:ring-stone-100 rounded-xl"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                required
                data-testid="admin-password-input"
                className="bg-white/60 border-stone-200 focus:border-stone-400 focus:ring-4 focus:ring-stone-100 rounded-xl"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full rounded-full px-8 py-6 text-lg bg-stone-800 text-stone-50 hover:bg-stone-700 shadow-lg transition-all duration-300 hover:scale-[1.02]"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};
